import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import Money from "../Common/Money";
import {getSession} from "../../services/Session/reducer";


interface OwnProps {
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartSubmitInfoComponent = (props: Props) => {
    const {t} = useTranslation();

    const renderDeliverInfo = () => {
        let minPriceView = null;

        if (props.session.order_type !== 'ROOM_SERVICE' && props.session.order_type !== 'DELIVERY') {
            if (props.session?.default_min_order_price_money) {
                minPriceView = (
                    <p className='mb-0'>
                        {t("common.word.min_order_price")}: <strong><Money
                        value={props.session?.default_min_order_price_money}/></strong>
                    </p>
                );
            }
        }
        if (props.session.order_type === 'ROOM_SERVICE') {
            if (props.session?.default_min_order_price_money) {
                minPriceView = (
                    <p className='mb-0'>
                        {t("common.word.min_order_price")}: <strong><Money
                        value={props.session?.default_min_order_price_money}/></strong>
                    </p>
                );
            }
        }
        if (props.session.order_type === 'DELIVERY') {
            if (props.session.min_order_price_money) {
                minPriceView = (
                    <p className='mb-0'>
                        {t("common.word.min_order_price")}: <strong><Money
                        value={props.session?.min_order_price_money}/></strong>
                    </p>
                )
            }
        }
        return minPriceView
    }

    const minPrice = renderDeliverInfo();
    return (
        <div className={"cart-submit-info-after"}>
            {minPrice && (
                <div className={"text-center mt-3"}>
                    {minPrice}
                </div>
            )}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartSubmitInfoComponent));
